import React from 'react';
import ReactDOM from 'react-dom';
import './styles.scss';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import { ToastContainer } from 'react-toastify';

ReactDOM.render(
  <React.Fragment>
    <App />
    <ToastContainer position='top-center' hideProgressBar />
  </React.Fragment>,
  document.getElementById('root')
);
